import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ViewSurveyForm from '../components/ViewSurveyForm';
import { Row, Col } from 'react-bootstrap';

const ViewSurvey = () => {
  const navigate = useNavigate();
  const surveyId = localStorage.getItem('selectedSurveyId'); // Obtiene el ID de localStorage

  useEffect(() => {
    if (!surveyId) {
      toast.error('No se encontró el ID de la encuesta.', { theme: 'colored' });
      navigate('/surveys'); // Redirige si no hay ID
    }
  }, [surveyId, navigate]);

  return (
    <>
      <Row>
        <Col>
          <ViewSurveyForm id={surveyId} />
        </Col>
      </Row>
    </>
  );
};

export default ViewSurvey;
